<p-dialog
    appDialogoPadrao="pi pi-check-square"
    descricao="Ícone exibido no card do serviço."
    [visible]="visivel()"
    (visibleChange)="visivel.set($event)"
    [dismissableMask]="true"
    header="Selecionar ícone"
    [style]="{ width: '640px', maxWidth: '95vw' }"
>
    <div class="flex flex-col gap-3">
        <input pInputText type="text" class="w-full" placeholder="Buscar ícone..." [ngModel]="busca()" (ngModelChange)="busca.set($event)" aria-label="Buscar ícone" />

        <div class="seletor-icone-grid">
            @for (icone of iconesFiltrados(); track icone) {
                <button
                    type="button"
                    class="seletor-icone-item"
                    [class.seletor-icone-item--ativo]="icone === selecionado()"
                    [pTooltip]="nome(icone)"
                    tooltipPosition="top"
                    [attr.aria-label]="'Selecionar ícone ' + nome(icone)"
                    (click)="escolher(icone)"
                >
                    <i [class]="icone" aria-hidden="true"></i>
                </button>
            } @empty {
                <p class="col-span-full text-center text-muted-color py-6">Nenhum ícone encontrado.</p>
            }
        </div>
    </div>
</p-dialog>
